import { render } from "./NewProductAttributeModal.vue?vue&type=template&id=1d997ea6"
import script from "./NewProductAttributeModal.vue?vue&type=script&lang=js"
export * from "./NewProductAttributeModal.vue?vue&type=script&lang=js"
script.render = render

export default script